var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFacebookGradient = function SvgFacebookGradient(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 39 38"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#facebook-gradient_svg__a)",
    d: "M19.857 38h-.084C9.323 38 .82 29.495.82 19.042v-.084C.82 8.505 9.323 0 19.773 0h.084c10.45 0 18.952 8.505 18.952 18.958v.084C38.81 29.495 30.307 38 19.857 38m-.084-36.714c-9.742 0-17.667 7.928-17.667 17.672v.084c0 9.744 7.925 17.672 17.667 17.672h.084c9.741 0 17.666-7.927 17.666-17.672v-.084c0-9.744-7.925-17.672-17.667-17.672z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#facebook-gradient_svg__b)",
    d: "M20.881 13.058v2.749h3.4l-.538 3.702H20.88v8.531a12.8 12.8 0 0 1-3.776-.04v-8.49H13.97v-3.703h3.135v-3.363a3.78 3.78 0 0 1 3.777-3.779v.002l.018-.002h3.382v3.202h-2.21a1.19 1.19 0 0 0-1.19 1.19z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "facebook-gradient_svg__a",
    x1: 10.318,
    x2: 35.654,
    y1: 0,
    y2: 37.993,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6937F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.276,
    stopColor: "#FFE5CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B08271"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "facebook-gradient_svg__b",
    x1: 16.548,
    x2: 30.259,
    y1: 8.665,
    y2: 19.544,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6937F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.276,
    stopColor: "#FFE5CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B08271"
  })))));
};
export default SvgFacebookGradient;